import { Action } from '../actions';
import {
  mergeEntities,
  mergeListEntities,
  Path,
  pluckListItemFromRawStoreSlice,
  removeEntityById,
  transformObjects,
} from '../helpers';
import { transformMilestone } from '../milestone/milestone.transformers';

export function threadMilestonesReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'threadMilestones') {
        const { result, refList } = action.payload;
        return mergeListEntities<'threadMilestones'>(
          state,
          transformObjects(result.milestones, transformMilestone),
          refList,
          'projectId',
        );
      }
      return state;
    }
    case 'WS_MESSAGE': {
      if (action.payload.parent_type === 'notifications') {
        const pathAndRef = (id: number) => {
          const path: Path<'threadMilestones'> = [
            'threadMilestones',
            String(id),
          ];
          return {
            path,
            ref: { path },
          };
        };
        switch (action.payload.type) {
          case 'cancelMilestone': {
            const { ref } = pathAndRef(action.payload.data.id);
            return removeEntityById<'threadMilestones'>(
              ref,
              state,
              action.payload.data.tranId,
            );
          }

          case 'createMilestone': {
            const { transId, project_id } = action.payload.data;
            const milestoneObj = {
              id: Number(transId),
              projectId: Number(project_id),
            };
            const { path, ref } = pathAndRef(milestoneObj.projectId);
            return mergeEntities<'threadMilestones'>(
              state,
              transformObjects([String(milestoneObj.projectId)], _ => {
                const threadMilestone = pluckListItemFromRawStoreSlice(
                  state,
                  path,
                  milestoneObj.id,
                );
                return {
                  ...threadMilestone,
                  ...milestoneObj,
                };
              }),
              ref,
            );
          }

          default:
            return state;
        }
      }
      return state;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/thread/threadMilestone.reducer.ts